export const dayList = [
  { id: "Monday", name: "Monday" },
  { id: "Tuesday", name: "Tuesday" },
  { id: "Wednesday", name: "Wednesday" },
  { id: "Thursday", name: "Thursday" },
  { id: "Friday", name: "Friday" },
  { id: "Saturday", name: "Saturday" },
  { id: "Sunday", name: "Sunday" },
];

export const monthList = [
  { id: "January", name: "January" },
  { id: "February", name: "February" },
  { id: "March", name: "March" },
  { id: "April", name: "April" },
  { id: "May", name: "May" },
  { id: "June", name: "June" },
  { id: "July", name: "July" },
  { id: "August", name: "August" },
  { id: "September", name: "September" },
  { id: "October", name: "October" },
  { id: "November", name: "November" },
  { id: "December", name: "December" },
];

export const subcontractorsAdhocCategoryList = [
  { id: "Deduct: Breakdown", name: "Deduct: Breakdown" },
  { id: "Deduct: No BA", name: "Deduct: No BA" },
  { id: "Deduct: See Remarks", name: "Deduct: See Remarks" },
  {
    id: "Termination/Last Day of Service",
    name: "Termination/Last Day of Service",
  },
  { id: "Add Route", name: "Add Route" },
  { id: "New Subcontractor", name: "New Subcontractor" },
  { id: "Pay: Ad-Hoc Trip", name: "Pay: Ad-Hoc Trip" },
  { id: "Pay: Ad-Hoc BA", name: "Pay: Ad-Hoc BA" },
  { id: "Change Area", name: "Change Area" },
  { id: "Change Route", name: "Change Route" },
  { id: "Backpay", name: "Backpay" },
  { id: "Deduct: No Show", name: "Deduct: No Show" },

  { id: "Rushowl standby activation", name: "Rushowl standby activation" },
  { id: "Pay: See Remarks", name: "Pay: See Remarks" },
  { id: "Pay: Under Package", name: "Pay: Under Package" },
]
